import React from 'react'
import classes from './Footer.module.css';
const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div>
            <div className={classes.copyright}>
                <p>Copyright © {currentYear} Promix Co-operative Management System. All rights reserved.</p>
                <p>
                    Terms&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Ask&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Our and Downloads&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Contact Us&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Need Help?&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Feedback
                </p>
            </div>
        </div>
    )
}
export default Footer
